import { CLEAR_SITE_DATA } from '../application';
import {
  RESET_COMPONENTS,
  RECEIVE_COMPONENTS,
  RECEIVE_STATUS,
  CREATE_COMPONENT_SUCCESS,
  COMPONENT_IMPORT_ERRORS,
  RECEIVE_REMOTE_ASSET_INFO,
  SET_PAGE_COMPONENTS,
  RESET_COMPONENTS_IMPORTED_AT,
} from './actions';

const initialState = {
  components: [],
  hashmap: {},
  remoteAssetInfo: {},
  siteLoaded: undefined,
  componentTree: {},
  componentsStatus: [],
  componentsStatusUpdatedAt: 0,
  componentsUpdatedAt: 0,
  componentsImportedAt: 0,
  createdComponent: {},
  importErrors: [],
  pageComponents: [],
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_COMPONENTS: {
      return {
        ...state,
        components: action.components,
        hashmap: action.hashmap,
        componentTree: action.componentTree,
        siteLoaded: action.siteId,
        componentsUpdatedAt: action.componentsUpdatedAt,
        componentsImportedAt: action.componentsImportedAt,
      };
    }
    case RECEIVE_REMOTE_ASSET_INFO: {
      const { componentId, assetInfo } = action;
      return { ...state, remoteAssetInfo: { ...state.remoteAssetInfo, [componentId]: assetInfo } };
    }
    case RECEIVE_STATUS: {
      return {
        ...state,
        componentsStatus: action.componentsStatus,
        componentsStatusUpdatedAt: action.componentsStatusUpdatedAt,
      };
    }
    case CREATE_COMPONENT_SUCCESS: {
      return { ...state, createdComponent: { id: action.id, parent: action.parent } };
    }
    case SET_PAGE_COMPONENTS: {
      return { ...state, pageComponents: action.pageComponents };
    }
    case RESET_COMPONENTS_IMPORTED_AT: {
      return { ...state, componentsImportedAt: 0 };
    }
    case COMPONENT_IMPORT_ERRORS: {
      return { ...state, importErrors: action.errors };
    }
    case RESET_COMPONENTS:
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
